import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ComponentService } from 'src/app/service/component.service';
import { OrderDetailsService } from '../../../../../service/myaccount/order-details.service';

@Component({
  selector: 'app-order-details-payment-return',
  templateUrl: './order-details-payment-return.component.html',
  styleUrls: ['./order-details-payment-return.component.scss'],
  standalone: false,
})
export class OrderDetailsPaymentReturnComponent implements OnInit, OnDestroy {
  orders$: Observable<any>;
  orderId: string;
  isPaymentTypeCC: boolean;
  showCardInfo: boolean;

  orderDetailsSubscription$: Subscription;
  // custom Order type
  order: any;

  constructor(protected orderDetailsService: OrderDetailsService, private componentService: ComponentService) {}

  ngOnInit() {
    const orderDetailsAPI = this.componentService.orderDetailsEntries$.getValue();
    this.order = orderDetailsAPI;
    const paymentDetails = this.order?.paymentInfoDetails;
    this.isPaymentTypeCC = paymentDetails?.cardType || paymentDetails.paymentType?.includes('SHIMANO_PG');
    this.showCardInfo = !!(
      paymentDetails?.cardType ||
      paymentDetails?.cardNumber ||
      paymentDetails?.expiration ||
      paymentDetails?.accountHolderName
    );

    // It will trigger this once cancel-edit order
    this.orderDetailsSubscription$ = this.componentService.orderDetails$.subscribe((orderDetails) => {
      this.order = orderDetails;
    });
  }

  ngOnDestroy() {
    if (this.orderDetailsSubscription$) {
      this.orderDetailsSubscription$.unsubscribe();
    }
  }
}
